import { IAppSettings } from '@msdyn365-commerce/core';

export interface IParametersConfig {
    [key: string]: string; // Les clés sont RecordId des attributs
}

// Configuration Fallback pour Sandbox et UAT
const UAT_CONFIG: IParametersConfig = {
    '5637155828': 'WBS_ITEM_NAME',
    '5637155829': 'WBS_ITEM_DESCRIPTION',
    '5637156580': 'WBS_ITEM_CATEGORY',
    '5637155830': 'WBS_USER_INSTRUCTION',
    '5637164076': 'WBS_INSTRUCTIONS_FOR_STORAGE',
    '5637155832': 'WBS_SALES_UNIT',
    '5637155831': 'WBS_BRAND',
    '5637155833': 'WBS_ITEM_INGREDIENTS',
    '5637164827': 'WBS_VOLUME_PRICING',
    '5637159586': 'WBS_SN_LOW_SALT',
    '5637159585': 'WBS_SN_LACTOSE_FREE',
    '5637159582': 'WBS_SN_GLUTEN_FREE',
    '5637159588': 'WBS_SN_MADE_ROMANIA',
    '5637159589': 'WBS_SN_NO_MSG_ADDED',
    '5637159587': 'WBS_SN_MADE_FRANCE',
    '5637159580': 'WBS_SN_CLEAN_LABEL',
    '5637159590': 'WBS_SN_ORGANIC',
    '5637159583': 'WBS_SN_HALAL',
    '5637159593': 'WBS_SN_VEGAN_FRIENDLY',
    '5637159594': 'WBS_SN_VEGETARIAN',
    '5637159591': 'WBS_SN_SALT_FREE',
    '5637159584': 'WBS_SN_HIGH_PROTEIN',
    '5637159595': 'WBS_SN_HIGH_CALORIE',
    '5637159578': 'WBS_SN_ADAPTED_TEXTURE',
    '5637159592': 'WBS_SN_TRANSIT',
    '5637159579': 'WBS_SN_ANTI_REFLUX',
    '5637159581': 'WBS_SN_DIABETIC_FRIENDLY',
    '5637146077': 'Storing_conditions_Factory',
    '5637157356': 'WBS_REJO_TDS_URL',
    '5637164826': 'WBS_NEW_ITEM',
    '5637160326': 'WBS_MTO_S002',
    '5637163326': 'WBS_CUST_HIERARCHY_SPECIFIC',
    '5637155835': 'WBS_CULINA_PREP_NAME',
    '5637157357': 'WBS_CULINA_PREP_DESCRIPTION',
    '5637155838': 'WBS_CULINA_PREP_MEAT',
    '5637158850': 'WBS_CULINA_PREP_INGREDIENTS',
    '5637158846': 'WBS_CULINA_PREP_STEPS',
    '5637157358': 'WBS_CULINA_PREP_PREPARATION_TIME',
    '5637159596': 'WBS_CULINA_PREP_COOKING_TIME',
    '5637156579': 'WBS_CULINA_PREP_DISPLAY',
    '5637157359': 'WBS_CULINA_PREP_FILT01',
    '5637157360': 'WBS_CULINA_PREP_FILT02',
    '5637158076': 'WBS_CULINA_PREP_FILT03',
    '5637158848': 'WBS_CULINA_PREP_FILT04',
    '5637158077': 'WBS_CULINA_PREP_FILT05',
    '5637158078': 'WBS_CULINA_PREP_FILT06',
    '5637158847': 'WBS_CULINA_PREP_FILT07',
    '5637159597': 'WBS_SALES_REPRESENTATIVE',
    '5637165576': 'WBS_VOLUME_PRICING_TABLE'
};

// Configuration fallback pour PROD
const PROD_CONFIG: IParametersConfig = {};

export const getParametersConfig = (appSettings: IAppSettings): IParametersConfig => {
    const parametersEnvironment = appSettings.config.parametersEnvironment || 'prod';

    switch (parametersEnvironment) {
        case 'uat':
            return UAT_CONFIG;
        case 'prod':
        default:
            return PROD_CONFIG;
    }
};

// Export des configurations pour faciliter les tests ou autres besoins
export const CONFIGS = {
    uat: UAT_CONFIG,
    prod: PROD_CONFIG
} as const;
